import { useState } from "react";

export default function ContactSection() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
    website_alt: "",
  });
  const [submitStatus, setSubmitStatus] = useState<"idle" | "loading" | "success" | "error">("idle");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (formData.website_alt.trim()) {
      setSubmitStatus("success");
      return;
    }

    setSubmitStatus("loading");

    const params = new URLSearchParams();
    params.append("name", formData.name);
    params.append("email", formData.email);
    params.append("subject", formData.subject);
    params.append("message", formData.message);

    try {
      const res = await fetch("https://readdy.ai/api/form/d916tc8bhec1he3oppp0", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: params.toString(),
      });
      if (res.ok) {
        setSubmitStatus("success");
        setFormData({ name: "", email: "", subject: "", message: "", website_alt: "" });
      } else {
        setSubmitStatus("error");
      }
    } catch {
      setSubmitStatus("error");
    }
  };

  return (
    <section id="contact" className="px-6 md:px-10 py-14 md:py-18 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <span className="inline-flex items-center px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            <i className="ri-mail-line mr-1.5"></i>
            联系我们
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            有料要爆？有合作要谈？
          </h2>
          <p className="text-sm text-foreground-500">
            无论是爆料线索、商务合作还是意见建议，都欢迎联系我们
          </p>
        </div>

        <div className="max-w-[900px] mx-auto grid grid-cols-1 lg:grid-cols-5 gap-8">
          {/* Left - Contact info */}
          <div className="lg:col-span-2 space-y-5">
            <div className="p-5 bg-background-100 rounded-xl border border-background-200/70">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-100 rounded-lg mb-3">
                <i className="ri-mail-line text-primary-600"></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-950 mb-1">
                爆料投稿
              </h3>
              <p className="text-xs text-foreground-500">tips@ijcbfgs.cn</p>
            </div>

            <div className="p-5 bg-background-100 rounded-xl border border-background-200/70">
              <div className="w-9 h-9 flex items-center justify-center bg-accent-100 rounded-lg mb-3">
                <i className="ri-briefcase-line text-accent-600"></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-950 mb-1">
                商务合作
              </h3>
              <p className="text-xs text-foreground-500">biz@ijcbfgs.cn</p>
            </div>

            <div className="p-5 bg-background-100 rounded-xl border border-background-200/70">
              <div className="w-9 h-9 flex items-center justify-center bg-secondary-100 rounded-lg mb-3">
                <i className="ri-user-voice-line text-secondary-600"></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-950 mb-1">
                意见建议
              </h3>
              <p className="text-xs text-foreground-500">feedback@ijcbfgs.cn</p>
            </div>
          </div>

          {/* Right - Contact form */}
          <div className="lg:col-span-3">
            <form
              data-readdy-form=""
              onSubmit={handleSubmit}
              className="bg-background-100 border border-background-200/70 rounded-xl p-5 md:p-6 space-y-4"
            >
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="contact-name" className="block text-xs font-medium text-foreground-700 mb-1.5">
                    你的名字
                  </label>
                  <input
                    id="contact-name"
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    required
                    placeholder="请输入你的名字"
                    className="w-full h-10 px-3.5 text-sm bg-background-50 border border-background-200 rounded-lg text-foreground-950 placeholder:text-foreground-400 outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400/30 transition-all"
                  />
                </div>
                <div>
                  <label htmlFor="contact-email" className="block text-xs font-medium text-foreground-700 mb-1.5">
                    邮箱地址
                  </label>
                  <input
                    id="contact-email"
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    required
                    placeholder="请输入你的邮箱"
                    className="w-full h-10 px-3.5 text-sm bg-background-50 border border-background-200 rounded-lg text-foreground-950 placeholder:text-foreground-400 outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400/30 transition-all"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="contact-subject" className="block text-xs font-medium text-foreground-700 mb-1.5">
                  主题
                </label>
                <input
                  id="contact-subject"
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                  required
                  placeholder="请简单描述主题"
                  className="w-full h-10 px-3.5 text-sm bg-background-50 border border-background-200 rounded-lg text-foreground-950 placeholder:text-foreground-400 outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400/30 transition-all"
                />
              </div>

              <div>
                <label htmlFor="contact-message" className="block text-xs font-medium text-foreground-700 mb-1.5">
                  留言内容
                </label>
                <textarea
                  id="contact-message"
                  name="message"
                  value={formData.message}
                  onChange={(e) => setFormData(e.target.value.length <= 500 ? { ...formData, message: e.target.value } : formData)}
                  required
                  maxLength={500}
                  rows={5}
                  placeholder="请详细描述你想说的内容（限500字）"
                  className="w-full px-3.5 py-2.5 text-sm bg-background-50 border border-background-200 rounded-lg text-foreground-950 placeholder:text-foreground-400 outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400/30 transition-all resize-none"
                ></textarea>
                <p className="text-xs text-foreground-400 mt-1 text-right">
                  {formData.message.length}/500
                </p>
              </div>

              {/* Honeypot */}
              <input
                type="text"
                name="website_alt"
                value={formData.website_alt}
                onChange={(e) => setFormData({ ...formData, website_alt: e.target.value })}
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
              />

              <button
                type="submit"
                disabled={submitStatus === "loading"}
                className="w-full h-11 bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 rounded-lg font-medium text-sm flex items-center justify-center gap-2 transition-colors duration-200 cursor-pointer disabled:opacity-60 whitespace-nowrap"
              >
                {submitStatus === "loading" ? (
                  <>
                    <i className="ri-loader-4-line animate-spin"></i>
                    发送中...
                  </>
                ) : (
                  <>
                    <i className="ri-send-plane-line"></i>
                    发送留言
                  </>
                )}
              </button>

              {submitStatus === "success" && (
                <div className="flex items-center gap-2 p-3 bg-primary-50 text-primary-700 rounded-lg text-xs">
                  <i className="ri-checkbox-circle-line"></i>
                  留言发送成功！我们会尽快回复你~
                </div>
              )}
              {submitStatus === "error" && (
                <div className="flex items-center gap-2 p-3 bg-accent-50 text-accent-700 rounded-lg text-xs">
                  <i className="ri-error-warning-line"></i>
                  发送失败，请稍后再试。或者直接发送邮件至 tips@ijcbfgs.cn
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
